import React, {Component} from 'react'
import Request from '../../request'
import {Button} from 'antd'
import {Icon, Popconfirm} from 'antd/lib/index'


export default class MoveToPrevDesk extends Component {
    sendBack = async () => {
        let x = await Request.changeDesk({
            _id: this.props._id,
            atLevel: this.props.atLevel
        })
        if (x.error) {

        } else {
            this.props.done()
        }
    }

    render() {

        if (this.props.type === 'popconfirm') {

            return (<Popconfirm
                title="Are you sure？"
                onConfirm={() => {
                    this.sendBack()
                }}
                icon={<Icon type="question-circle-o" style={{color: 'red'}}/>}
            >
                <Button
                    size={'small'}
                >{this.props.text}</Button>

            </Popconfirm>)
        }

        return <Button onClick={this.sendBack} type={this.props.type}>{this.props.text}</Button>
    }
}
